// Utility function to format date as dd-mm-yyyy
export const formatDateOnly = (isoDate) => {
    if (!isoDate) return '';
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
};

// Utility function to format date and time as dd-mm-yyyy HH:MM:SS
export const formatDateTime = (isoDate) => {
    if (!isoDate) return '';
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

const HAS_OFFSET = /(Z|[+-]\d{2}:?\d{2})$/i;
const ISO_DATE_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/;

export const parseUtcDate = (value) => {
    if (value instanceof Date) return value;
    const text = String(value);
    return new Date(ISO_DATE_TIME.test(text) && !HAS_OFFSET.test(text) ? `${text}Z` : text);
};

const timeZoneName = (date, locale) =>
    new Intl.DateTimeFormat(locale, { timeZoneName: "short" }).formatToParts(date).find((part) => part.type === "timeZoneName")?.value;

export const timeZoneAbbreviation = (date) => {
    const britishName = timeZoneName(date, "en-GB");
    return britishName && !/^GMT[+-]/.test(britishName) ? britishName : timeZoneName(date, "en-US");
};

export const formatLogDateTime = (value) => {
    if (!value) return "-";
    const date = parseUtcDate(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return `${date.toLocaleString("en-GB")} ${timeZoneAbbreviation(date)}`;
};
